import { actions as entityActions } from '../../../../data/store';

import { IProperty } from '../../../../data/entities/property';
import { getProperty } from '../../../../entities/properties/selectors';
import { ActionTypeNames, ActionValues, createActionCreators } from '../../../../store/actions';
import { ThunkAction } from '../../../../store/middleware';

export const adminLoadPropertyActions = createActionCreators<
	{ T: 'ADMIN_VIEW_PROPERTY_REQUEST', P: { id: string } },
	{ T: 'ADMIN_VIEW_PROPERTY_RECEIVE', P: { property: IProperty } },
	{ T: 'ADMIN_VIEW_PROPERTY_FAILURE', P: { id: string, error: Error } }
>('ADMIN_VIEW_PROPERTY_REQUEST', 'ADMIN_VIEW_PROPERTY_RECEIVE', 'ADMIN_VIEW_PROPERTY_FAILURE');

export const requestAdminProperty = (id: string) => adminLoadPropertyActions.ADMIN_VIEW_PROPERTY_REQUEST({ id });
export const receiveAdminProperty = (property: IProperty) => adminLoadPropertyActions.ADMIN_VIEW_PROPERTY_RECEIVE({ property });
export const failureAdminProperty = (id: string, error: Error) => adminLoadPropertyActions.ADMIN_VIEW_PROPERTY_FAILURE({ id, error });

export const getPropertyAndCustomerForAdminView = (id: number | string): ThunkAction<any> => async (dispatch, getState, { _deprecatedApi: api }) => {
	dispatch(requestAdminProperty(id.toString()));
	try {
		await dispatch(entityActions.property.getById(id));
		const newState = getState();
		const property = getProperty(id, newState);
		if (property) {
			const owner = newState.data.customers.byId[property.owner_id];
			if (!owner) {
				await dispatch(entityActions.customer.getById(property.owner_id));
			}
		}
		dispatch(receiveAdminProperty(getProperty(id, getState()) as IProperty));
	} catch (e) {
		dispatch(failureAdminProperty(id.toString(), e));
	}
};

const actions = { ...adminLoadPropertyActions };

type AdminPropertyViewActions = ActionValues<typeof actions>;
type AdminPropertyViewActionsTypes = ActionTypeNames<AdminPropertyViewActions>;

export type Actions = AdminPropertyViewActions[keyof AdminPropertyViewActions];
export const ActionTypes = Object.keys(actions).reduce((types, t) => {
	types[t] = t;
	return types;
}, {} as AdminPropertyViewActionsTypes);
